// We use this type to define the type of the sub element and to get/edit the values of the field array in the form
export enum EListFieldType {
  PHONES = "phones",
  EMAILS = "emails",
  WEBSITES = "websites",
  ADDRESSES = "addresses",
  OWNERS = "owners",
}
